var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tour-summary__icons" },
    [
      _c(
        "SwiperCarousel",
        {
          attrs: {
            name: "tour-summary__icons",
            speed: 7000,
            autoplayDelay: 0,
            loop: true,
            freeMode: false,
            slidesPerViewMobile: 2,
            slidesPerViewTablet: 3,
            slidesPerViewDesktop: 4,
          },
        },
        _vm._l(_vm.icons, function (icon, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "swiper-slide",
              class: { "tour-summary__details-descriptionTs": _vm.isTs },
            },
            [
              _c("picture", [
                _c("img", {
                  attrs: {
                    src: icon.imageUrl,
                    alt: icon.imageAltTagText,
                    loading: "lazy",
                  },
                }),
              ]),
              _vm._v("\n\n            " + _vm._s(icon.title) + "\n        "),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }